import React from "react";
import moduleStyle from "./Badge.module.css";
import LockIcon from "@material-ui/icons/Lock";

export const Badge = ({ showBadge, className = "" }) => {
  return (
    <>
      {showBadge && (
        <div
          className={`${moduleStyle.chip} d-flex align-items-center fit_content pointer ${className}`}
        >
          <LockIcon className={moduleStyle.lockIcon} />
          <div className={`ml-2 ${moduleStyle.label}`}>Locked</div>
        </div>
      )}
    </>
  );
};
